<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

  <div class="addingSample-upload-continer">
    <div class="addingSample">
      <p-fieldset legend="Adding Samples" class="addingSample-fieldSet">
        <div style="height: 13.5rem;">
          <div style="padding: 1rem;">
            <div class="ui-inputgroup">
              <button pButton class="theme-button noHover labelButton mr-2" type="button"
                label="Project-ID"></button>
              <p-dropdown  placeholder="Select Project ID" filter="true" [options]="projectsList" name="projectList"
                [(ngModel)]="selectedProject" [showClear]="true">
              </p-dropdown>
            </div>
          </div>
          <div class="date-input-continer">
            <div class="from-input" style="padding: 1rem;">
              <div class="ui-inputgroup">
                <button pButton class="theme-button noHover labelButton mr-2" type="button"
                  label="Received Date"></button>
                    <p-calendar [(ngModel)]="receivedDate" showTime="true" size="10" dateFormat="dd.mm.yy" [showIcon]="true"></p-calendar>
              </div>
            </div>
            <div class="to-input">
              <div class="ui-inputgroup" style="padding: 1rem;">
                <button pButton class="theme-button noHover labelButton mr-2" type="button"
                  label="Box-ID"></button>
                <input style="height: 2.14rem;width: 59%;border: 1px solid #ced4da !important;" [(ngModel)]="scannedBox" (keydown.enter)="scanBoxID()">
              </div>
            </div>
          </div>
        </div>
      </p-fieldset>
      <div class="col-12 flex p-0">
        <div class="col-7">
          <div class="tableLHS1">
            <p-table [value]="boxDeliveryList" selectionMode="single" [(selection)]="tableSelectedRow" name="allPlates"
              ngDefaultControl [loading]="loading">
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col" class="batch">Sender Box-ID</th>
                  <th scope="col" class="status">Project</th>
                </tr>
              </ng-template>
              <ng-template let-index="rowIndex" pTemplate="body" let-boxDeliveryList>
                <tr [pEditableRow]="boxDeliveryList">
                  <ng-container>
                    <td scope="col" style="width: 45%;" class="normalBody pr-0">{{boxDeliveryList?.boxId}}</td>
                    <td scope="col" style="width: 45%;" class="normalBody pr-0">{{boxDeliveryList?.projectId}}</td>
                  </ng-container>
                  <ng-container>
                    <td style="text-align:center; padding: 0.1rem;">
                      <button pButton type="button" pCancelEditableRow icon="pi pi-trash" (click)="removeRow(index+1)"
                        class="trash"></button>
                    </td>
                  </ng-container>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="ui-inputgroup col-2 receptionButton">
          <button style="width: 13rem;" pButton class="buttonsRound thirdButton" label="Complete Box Reception"
            (click)="completeBoxReception()" [disabled]="!boxDeliveryList || boxDeliveryList.length === 0"></button>
        </div>
      </div>
    </div>
    <div class="search">
      <p-fieldset legend="Search">
        <div class="flex">
          <div class="col-5 parent mt-1 upload-match">
            <div class="to-input">
              <div class="ui-inputgroup buttonPadding">
                <button pButton class="theme-button noHover labelButton mr-2" type="button"
                  label="Box-ID"></button>
                <input class="border-left" pInputText id="input" placeholder="Box-ID" [(ngModel)]="searchBox">
              </div>
            </div>
            <div class="date-input-continer">
              <div class="from-input buttonPadding">
                <div class="ui-inputgroup">
                  <button pButton class="theme-button noHover labelButton mr-2" type="button"
                    label="Date From:"></button>
                  <p-calendar [(ngModel)]="fromDate" size="10" dateFormat="dd.mm.yy" [showIcon]="true"></p-calendar>
                </div>
              </div>
            </div>
            <div class="date-input-continer">
              <div class="ui-inputgroup buttonPadding">
                <button pButton class="theme-button noHover labelButton mr-2" type="button"
                  label="Project-ID"></button>
                <p-dropdown placeholder="Select Project-ID" class="senderDropDown"  [options]="projectsList"
                  filter="true" name="projectList" [(ngModel)]="searchProjectID">
                </p-dropdown>
              </div>
            </div>
          </div>

          <div class="col-5 parent mt-1 upload-match">
            <div class="to-input">
              <div class="ui-inputgroup buttonPadding">
                <button pButton class="theme-button noHover labelButton mr-2" type="button"
                  label="Sample-ID"></button>
                <input style="height: 2.2rem;width: 60%; border: 1px solid #ced4da !important;" [(ngModel)]="searchsampleID">
              </div>
            </div>
            <div class="date-input-continer">
              <div class="from-input">
                <div class="ui-inputgroup buttonPadding">
                  <button pButton class="theme-button noHover labelButton mr-2" type="button"
                    label="Date Until:"></button>
                  <p-calendar [(ngModel)]="toDate" size="10" dateFormat="dd.mm.yy" [showIcon]="true"></p-calendar>
                </div>
              </div>
            </div>
          </div>

          <div class="col-1 parent mt-1 upload-match">
            <div class="ui-inputgroup">
              <div class="ui-g-12 ">
                <div class="ui-inputgroup buttonPadding">
                  <button pButton label="Clear" (click)="clearSelection()" class="buttonsRound thirdButton"></button>
                </div>
                <div><br></div>

                <div class="ui-inputgroup buttonPadding">
                  <button pButton label="Search" (click)="searchDeliveryList(0,20)"
                    class="buttonsRound thirdButton"></button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </p-fieldset>
      <div style="margin-top: 5px;">
        <p-table [columns]="cols" [value]="boxlist" tableStyleClass="samples-table" selectionMode="single"
          [loading]="loading" selectionMode="single" [paginator]="true" [rows]="20" [lazy]="true"
          (onLazyLoad)="loadLazy($event)" [totalRecords]="totalBoxes">
          <ng-template pTemplate="caption">
            <div style="text-align: center;">
              Delivery Tracking
            </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="col" *ngFor="let col of columns" [ngStyle]="{'width': col.width}">
                {{col.header}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-boxlist>
            <tr [pSelectableRow]="boxlist">
              <td>
                {{boxlist.boxId}}
              </td>
              <td>
                {{boxlist.sender}}
              </td>
              <td>
                {{boxlist.projectId}}
              </td>
              <td>
                {{boxlist.status}}
              </td>
              <td>
                {{boxlist.receptionDate | date:'dd.MM.yyyy'}}
              </td>
              <td>
                {{boxlist.puid}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-boxlist>
            <tr>
              <td [attr.colspan]="boxlist.length">
                No records found
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>